/**
 * Lead origin/UTM tracking shipped with every lead form submit.
 * UTM params are persisted in sessionStorage on first sight so attribution
 * survives navigation from the landing page to /brochure, /fse, /eventi, ...
 */
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORE_KEY = 'pv_utm';

export function getLeadTracking() {
  const out = {};
  try {
    out.source_page_url = window.location.href.slice(0, 500);
    if (document.referrer) out.source_referrer = document.referrer.slice(0, 500);

    let stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    } catch {
      stored = {};
    }
    const current = {};
    const u = new URL(window.location.href);
    UTM_KEYS.forEach((k) => {
      const v = u.searchParams.get(k);
      if (v && v.trim()) current[k] = v.trim().slice(0, 120);
    });
    const merged = { ...stored, ...current };
    if (Object.keys(current).length > 0) {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify(merged));
      } catch {
        /* private mode */
      }
    }
    UTM_KEYS.forEach((k) => {
      if (merged[k]) out[k] = merged[k];
    });
  } catch {
    /* SSR / privacy mode — ship what we have */
  }
  return out;
}
